import { Mentionable } from 'vue-mention'

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.component('Mentionable', Mentionable, {})
})
